import React from 'react';
import { Paper, Box, List, Typography, Divider } from '@material-ui/core';

// Import utilities
import { useTranslations } from 'components/utilities';

// Import components
import {
	TermsAndConditionsPolicyListItem,
	PolicyListItem,
} from 'components/elements';

const DetailsPolicies = ({ boxSizes }) => {
	const { t } = useTranslations();

	return (
		<Paper>
			<Box {...boxSizes}>
				<List>
					<TermsAndConditionsPolicyListItem />

					<Divider />

					<PolicyListItem
						title={t('policy.cancellationPolicy.title')}
						content={
							<Typography>{t('policy.cancellationPolicy.content')}</Typography>
						}
					/>
				</List>
			</Box>
		</Paper>
	);
};

export default DetailsPolicies;
